function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgComercioEEscritorio = function SvgComercioEEscritorio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.26 19.747v-9.054a2.698 2.698 0 002.134-1.136 2.698 2.698 0 002.201 1.137c.909 0 1.713-.449 2.202-1.137a2.698 2.698 0 004.404 0 2.698 2.698 0 004.404 0 2.698 2.698 0 002.136 1.136v9.054c0 .573-.464 1.037-1.037 1.037h-2.503v-5.122a2 2 0 00-2-2H8.799a2 2 0 00-2 2v5.122H4.295a1.036 1.036 0 01-1.036-1.037zM.54 8.513a2.703 2.703 0 001.72 2.015v9.22c0 1.124.91 2.036 2.035 2.036h15.41a2.037 2.037 0 002.036-2.037v-9.22a2.704 2.704 0 001.718-2.014 1.95 1.95 0 00-.043-.903L22.3 3.657A2 2 0 0020.375 2.2H3.625a2 2 0 00-1.924 1.457L.585 7.61a1.95 1.95 0 00-.044.903zM11.5 20.784H7.799v-5.122a1 1 0 011-1H11.5v6.122zm1 0h3.7v-5.122a1 1 0 00-1-1h-2.7v6.122zM20.375 3.2a1 1 0 01.963.729l1.115 3.953a.953.953 0 01.025.44 1.703 1.703 0 01-3.372-.315l-.005-.495h-.992l-.004.495a1.703 1.703 0 01-3.403 0l-.005-.495h-.993l-.004.495a1.701 1.701 0 01-3.402 0l-.005-.495h-.992l-.004.495a1.702 1.702 0 01-3.403 0l-.005-.495h-.992l-.004.495a1.702 1.702 0 01-3.371.315.954.954 0 01.025-.44l1.117-3.953a1 1 0 01.962-.729h16.75z",
    fill: props.color
  }));
};
SvgComercioEEscritorio.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgComercioEEscritorio.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgComercioEEscritorio;